import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_yourMission = () =>
	queryOptions({
		queryKey: ["personal-mission", "your-mission"] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.personalMission.personalMissionControllerGet({
					signal: context.signal,
				}),
			),
		retry: false,
	});
